module.exports = __webpack_public_path__ + "img/contacts.b7c0582c.svg";